export const ASSETS_CDN_MAP: Record<string, string> = {
  development: 'https://world-assets-dev.viverse.com',
  stage: 'https://world-assets-stage.viverse.com',
  next: 'https://world-assets-next.viverse.com',
  production: 'https://world-assets.viverse.com',
}

export const ALLOWED_ASSETS_DOMAINS = Object.values(ASSETS_CDN_MAP).map(
  (url) => new URL(url).hostname,
)

/**
 * Width of the canonical room cover derivative. Shared so the URL advertised in og:image,
 * twitter:image, the JSON-LD #primaryimage and the detail-page thumbnail's `src` stay
 * byte-identical — Google only treats them as one image if the URLs match exactly.
 */
export const CANONICAL_COVER_SRC_WIDTH = 1200
